// extracted by mini-css-extract-plugin
module.exports = {"avatarCover":"PickingList_avatarCover__vXY9C"};